var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty"},[_c('img',{attrs:{"src":require("@/assets/empty_icon.png")}}),_c('span',[_vm._v(_vm._s(_vm.content))])])
}
var staticRenderFns = []

export { render, staticRenderFns }